import { CaretRightIcon } from '@phosphor-icons/react/dist/ssr';

// New "Partner" nav tab — mirrors innovaccer.com's Partner dropdown: an "Our Partners"
// column of brand logos (Mastek, Coforge) on the left and an "Announcements" column
// (single card, non-linked, matching the live markup) on the right.
export const PARTNERS = [
  { label: 'Mastek',  logo: 'https://cdn.prod.website-files.com/670e4ade75003c7364a3944d/6a9ea492f4d196855d2e1b2c_Brand%20Icons%20(2).png', href: 'https://innovaccer.com/partnerships/mastek' },
  { label: 'Coforge', logo: 'https://cdn.prod.website-files.com/670e4ade75003c7364a3944d/6a9ea50747c3a68fbc5b23a5_Brand%20Icons%20(3).png', href: 'https://g-forge.ai/' },
];

const ANNOUNCEMENT_TITLE = 'Delivering Autonomous Healthcare Operations at Global Scale';
const ANNOUNCEMENT_HREF  = 'https://innovaccer.com/partnerships/mastek';
const ANNOUNCEMENT_IMG   = 'https://cdn.prod.website-files.com/670e4ade75003c7364a3944d/6a9ea37d8a15267c174dd0fc_Frame%201171277210.png';

interface NavDropdownPartnerProps {
  className?: string;
}

export default function NavDropdownPartner({ className = '' }: NavDropdownPartnerProps) {
  return (
    <div className={`nav-dropdown nav-dropdown--fit${className ? ` ${className}` : ''}`} style={{ width: 'fit-content' }}>
      <div className="nav-dropdown__body nav-dropdown__body--row">

        {/* Our Partners */}
        <div className="nav-dropdown__section">
          <p className="nav-dropdown__section-label nav-dropdown__section-label--customers">Our Partners</p>
          <div className="nav-dropdown__resource-list">
            {PARTNERS.map(({ label, logo, href }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="nav-dropdown__resource-item">
                <div className="nav-dropdown__resource-icon" style={{ background: 'transparent' }}>
                  <img src={logo} alt={label} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                </div>
                <span className="nav-dropdown__resource-label">{label}</span>
              </a>
            ))}
          </div>
        </div>

        {/* Announcements */}
        <div className="nav-dropdown__section">
          <p className="nav-dropdown__section-label nav-dropdown__section-label--customers">Announcements</p>
          <a href={ANNOUNCEMENT_HREF} target="_blank" rel="noopener noreferrer" className="nav-dropdown__featured-card">
            <div className="nav-dropdown__featured-title-row">
              <span className="nav-dropdown__featured-title">{ANNOUNCEMENT_TITLE}</span>
              <CaretRightIcon size={14} weight="bold" style={{ color: 'var(--seasons-color-text-tertiary)', flexShrink: 0, marginTop: 'var(--seasons-space-1)' }} />
            </div>
            <div className="nav-dropdown__featured-image">
              <div className="nav-dropdown__featured-bg-layer">
                <img src="https://storage.googleapis.com/cms_rewire/nav-featured-bg.png" alt="" />
              </div>
              <div className="nav-dropdown__featured-doc-layer nav-dropdown__featured-doc-layer--scale">
                <img src={ANNOUNCEMENT_IMG} alt={ANNOUNCEMENT_TITLE} />
              </div>
            </div>
          </a>
        </div>

      </div>
    </div>
  );
}
